import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'isomorphic-dompurify';

import VanillaPopOut from '../../modules/PopOut';

let popOutInstance;

const PopOut = ({ info, children, parentContainerSelector, belowOnly }) => {
  const controlElement = useRef(null);

  useEffect(() => {
    if (controlElement.current) {
      popOutInstance = new VanillaPopOut(controlElement.current);
    }

    return () => {
      if (popOutInstance) {
        popOutInstance.destroy();
      }
    };
  }, []);

  const belowModifier = belowOnly ? ' PopOut-belowOnly' : '';

  return (
    <>
      {!!info &&
        <div data-component="PopOut" data-pop-out="control" ref={controlElement} data-pop-out-parent-container-selector={parentContainerSelector}>
          <div className={`PopOut${belowModifier}`} data-pop-out="container">
              <div className="PopOut_content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(info) }}></div>
          </div>
          <div data-pop-out="hit-parent">
            {children}
          </div>
        </div>
      }
    </>
  );
};

PopOut.propTypes = {
  children: PropTypes.node.isRequired,
  info: PropTypes.string.isRequired,
};

export default PopOut;
